export const SHOWCASE_SECTIONS = [
  {
    id: 'dashboard', title: 'Front-desk Dashboard',
    value: 'One screen tells the team how the day is going: today’s appointments, who is in a test right now, new registrations and collections. Alerts for low stock, recalls and borrowed devices sit on top so nothing slips.',
    features: ['Live counters for appointments, new patients, tests and collections', 'Needs-attention strip: recalls, low stock, devices pending, loaners due', 'Quick actions to book, register, start a test or record a sale', 'Branch switcher for multi-location clinics'],
    shots: ['01-dashboard'],
  },
  {
    id: 'patients', title: 'Patient Registration & Records',
    value: 'Every patient gets one profile with an MRD number, history timeline, visits, reports, payments and service tickets. Staff find anyone in seconds by name, mobile or MRD.',
    features: ['Walk-in registration with strict 10-digit mobile validation', 'Complete history timeline across tests, invoices and repairs', 'Family linking and duplicate merge', 'CSV export and weekly email digest'],
    shots: ['02-patients', '02b-patient-profile'],
  },
  {
    id: 'appointments', title: 'Appointments & Calendar',
    value: 'Book, reschedule and check in patients from a list or a week calendar. Each audiologist has a colour, and recommended tests ride along with the booking.',
    features: ['Today / tomorrow / 7-day views with status filters', 'Week and day calendar per staff member', 'Tests chosen at booking flow into the test queue', 'Automatic WhatsApp / SMS reminders'],
    shots: ['03-appointments', '03b-calendar'],
  },
  {
    id: 'tests', title: 'Hearing Tests Queue',
    value: 'A live board moves each patient from Waiting to Checked-in, In progress and Completed. Audiologists see who is next and launch the right test with one tap.',
    features: ['Kanban queue fed by tokens, appointments and walk-ins', 'PTA, impedance, speech, OAE, BERA, tinnitus and paediatric tests', 'Resume half-finished sessions any time', 'Daily counts of pending and completed tests'],
    shots: ['04-hearing-tests'],
  },
  {
    id: 'reports', title: 'Audiogram Reports',
    value: 'Results turn into a clean, branded hearing assessment on the clinic letterhead, ready to print, download or share on WhatsApp.',
    features: ['Standard audiogram charts with masking and legends', 'Branch-aware letterhead, signature and seal', 'Split or combined ear layouts, fit-to-A4', 'Share with the patient on WhatsApp in one click'],
    shots: ['05-audiogram'],
  },
  {
    id: 'trials', title: 'Hearing Aid Trials & Sales',
    value: 'Track every take-home trial from issue to conversion, with deposits, due dates and overdue flags. Quotations, fittings, upgrades and follow-ups live in the same module.',
    features: ['Trial issue with serials, deposit and expected return', 'Overdue, converted, returned and lost tracking', 'Quotations, fittings, ear moulds and custom hearing aids', 'Follow-up reminders after every fitting'],
    shots: ['06-ha-trials'],
  },
  {
    id: 'inventory', title: 'Inventory & Serial Tracking',
    value: 'Every hearing aid is tracked by serial number across branches: in stock, on trial, sold, in service or loaned. Purchase orders and goods receipts keep stock honest.',
    features: ['Serial-level board with full lifecycle timeline', 'Saleable, demo and accessory stock pools', 'Vendors, purchase orders and goods receipts', 'Inter-branch stock transfers and AMC plans'],
    shots: ['07-inventory'],
  },
  {
    id: 'repair', title: 'Service & Repair',
    value: 'Repairs, cleaning and warranty claims follow one ticket from intake to vendor, approval and delivery, so the front desk can always answer “where is my hearing aid?”.',
    features: ['Ticket pipeline with vendor dispatch and courier tracking', 'Customer estimates and approvals', 'Loaner devices while repairs are in progress', 'Warranty vs paid work clearly separated'],
    shots: ['08-repair'],
  },
  {
    id: 'billing', title: 'Billing & GST Invoices',
    value: 'Create GST-ready invoices for tests, hearing aids and accessories in seconds. Today’s collections are always visible at the top.',
    features: ['Invoices, advances and credit notes', 'Service catalogue with prices and tax settings', 'Paid / due status with balance tracking', 'Print or email on the branch letterhead'],
    shots: ['09-invoices'],
  },
  {
    id: 'payments', title: 'Payments & End of Day',
    value: 'Every payment and refund is logged with method and reference. The End-of-Day report closes the day with footfall, tests and cash, ready to print or send.',
    features: ['Cash, UPI, card and advance payments in one ledger', 'Refunds and reversals with reasons', 'End-of-Day summary by branch, with cash drawer', 'Share the EOD on email or WhatsApp'],
    shots: ['10-payments', '10b-eod'],
  },
  {
    id: 'analytics', title: 'Revenue & Analytics',
    value: 'Owners see revenue by day, stream, brand and team member, plus the commercial funnel from consultation to sale.',
    features: ['Revenue dashboard with date ranges and branch filter', 'Brand split and team performance', 'Consultation → quote → trial → sale funnel', 'CSV exports for sales, revenue and inventory'],
    shots: ['11-revenue', '11b-analytics'],
  },
  {
    id: 'referrals', title: 'Referral Corner',
    value: 'See which doctors send patients, what revenue they bring and what payout is owed each month, without spreadsheets.',
    features: ['Per-doctor patients, diagnostics and hearing-aid revenue', 'Percent or flat payout rules per doctor', 'Monthly payout reports as CSV', 'Drill-down into every referred patient'],
    shots: ['12-referrals'],
  },
  {
    id: 'settings', title: 'Settings, Branches & Compliance',
    value: 'Set up the clinic once: branches, staff, roles, working hours, services and print templates. A ready policy pack helps clinics meet DPDP Act and ISO 27001 expectations.',
    features: ['Multi-branch and franchise setup with own letterheads', 'Role-based access for owner, audiologist, front desk and accounts', 'Patient data masked from platform staff by default', 'Seven e-signable compliance policies'],
    shots: ['13-settings', '13b-compliance'],
  },
];
